import { useState, useRef, useEffect } from 'react';
import { CITIES } from './cities';
import { MapPin } from './icons';

// Şık şehir seçici. activeSlug boş ("") ise "Ankara (Genel)" seçilidir.
export const CitySwitcher = ({ activeSlug, activeName, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onEsc = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onEsc);
    };
  }, [open]);

  const norm = (s) => s.toLocaleLowerCase('tr');
  const filtered = CITIES.filter((c) => !q || norm(c.name).includes(norm(q)));

  const choose = (slug, name) => {
    onSelect(slug, name);
    setOpen(false);
    setQ('');
  };

  return (
    <div className="city-switcher" ref={ref} data-testid="city-switcher">
      <button
        type="button"
        className="city-switcher-btn"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        data-testid="city-switcher-button"
      >
        <MapPin />
        <span className="city-switcher-label">{activeName || 'Ankara'}</span>
        <svg className={`city-switcher-caret ${open ? 'up' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
      </button>

      {open && (
        <div className="city-switcher-panel" role="listbox" data-testid="city-switcher-panel">
          <input
            className="city-switcher-search"
            type="text"
            placeholder="Şehir ara..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
            data-testid="city-switcher-search"
          />
          <div className="city-switcher-list">
            {(!q || 'ankara genel'.includes(norm(q))) && (
              <button
                type="button"
                className={`city-switcher-item pinned ${!activeSlug ? 'active' : ''}`}
                onClick={() => choose('', 'Ankara')}
                data-testid="city-option-ankara"
              >
                Ankara <span className="city-switcher-tag">Varsayılan</span>
              </button>
            )}
            {filtered.map((c) => (
              <button
                type="button"
                key={c.slug}
                className={`city-switcher-item ${activeSlug === c.slug ? 'active' : ''}`}
                onClick={() => choose(c.slug, c.name)}
                data-testid={`city-option-${c.slug}`}
              >
                {c.name}
              </button>
            ))}
            {filtered.length === 0 && <p className="city-switcher-empty">Sonuç bulunamadı</p>}
          </div>
        </div>
      )}
    </div>
  );
};
